// const authChannel = new BroadcastChannel("auth-sync");

// export const getToken = () => localStorage.getItem("token");
// export const getRefreshToken = () => localStorage.getItem("refresh_token");
// export const getTokenExpiry = () => {
//   const e = localStorage.getItem("token_expiry");
//   return e ? Number(e) : null;
// };

// export const saveTokens = ({ access_token, refresh_token }) => {
//   if (access_token) localStorage.setItem("token", access_token);
//   if (refresh_token) localStorage.setItem("refresh_token", refresh_token);

//   authChannel.postMessage({ type: "TOKEN_UPDATE" });
// };

// export const setTokenExpiry = (expiry) => {
//   localStorage.setItem("token_expiry", String(expiry));
// };

// export const clearAuth = () => {
//   ["token", "refresh_token", "token_expiry", "username", "userId", "dashboard_access"]
//     .forEach(k => localStorage.removeItem(k));

//   authChannel.postMessage({ type: "LOGOUT", self: true });
// };

// authChannel.onmessage = (e) => {
//   if (e.data?.type === "LOGOUT" && !e.data.self) {
//     window.location.href = "/login";
//   }
// };

// export const getAuthHeaders = () => ({
//   Authorization: `Bearer ${getToken()}`,
//   "Content-Type": "application/json",
// });

const authChannel = new BroadcastChannel("auth-sync");

export const getToken = () => localStorage.getItem("token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");
export const getTokenExpiry = () => {
  const e = localStorage.getItem("token_expiry");
  return e ? Number(e) : null;
};

export const saveTokens = ({ access_token, refresh_token }) => {
  if (access_token) localStorage.setItem("token", access_token);
  if (refresh_token) localStorage.setItem("refresh_token", refresh_token);

  authChannel.postMessage({ type: "TOKEN_UPDATE" });
};

export const setTokenExpiry = (expiry) => {
  localStorage.setItem("token_expiry", String(expiry));
};

export const clearAuth = () => {
  [
    "token",
    "refresh_token",
    "token_expiry",
    "username",
    "userId",
    "dashboard_access",
    "role",       // ← ADDED
    "userRole",   // ← ADDED (clears old key too)
    "designation", // ← ADDED
    "employeeData", // ← ADDED (clears old key)
  ].forEach((k) => localStorage.removeItem(k));

  authChannel.postMessage({ type: "LOGOUT", self: true });
};

authChannel.onmessage = (e) => {
  if (e.data?.type === "LOGOUT" && !e.data.self) {
    window.location.href = "/login";
  }
};

export const getAuthHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});